import {
  BaseEquipment,
  EquipmentCombinations,
} from 'fitbeat.models';
import React from 'react';
import { SafeAreaView, TouchableOpacity, View } from 'react-native';
import { connect } from 'react-redux';
import {
  CardioOrResistance,
  ProcessTypes,
  WorkoutSettings,
} from 'fitbeat.gym-core';
import { Icon } from '../../components';
import { IAppStore } from '../../HomeWorkouts';
import theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
import {
  getNextBookingStep,
  openPersonaliseWorkoutSetupScreen,
  workoutSettingsUpdated,
} from '../actions';
import TypeOfWorkoutWarning from '../components/TypeOfWorkoutWarning';
import { recommendedSettingsSelector } from '../selectors';
import { PersonaliseSetupScreens } from './personaliseWorkoutSteps/types';

function TypeOfWorkoutWarningStepComponent({
  getNextBookingProcessStep,
  userProfile,
  recommendedSettings,
  getRecommendedSetttingsSuccess,
  workoutToChangeTo,
}) {
  const headerOffset = defaultScale(65);
  const onBackPress = () => {
    getNextBookingProcessStep(userProfile, ProcessTypes.WorkoutSettings);
  };

  const renderWarningHeader = () => (
    <View style={{ zIndex: 10 }}>
      <SafeAreaView style={{ flex: 0 }} />
      <TouchableOpacity
        style={{ margin: defaultScale(15) }}
        onPress={onBackPress}
      >
        <Icon
          name='ios-arrow-back'
          color={theme.BLACK}
          size={defaultScale(35)}
        />
      </TouchableOpacity>
    </View>
  );

  const saveAndClose = () => {
    let newSettings = {};
    if (workoutToChangeTo === CardioOrResistance.Balance) {
      newSettings = {
        threeBodyGroups: WorkoutSettings.getFullBody(),
        allowBagContact: false,
      };
    }
    const customSettingsIgnoredFromProgram = new WorkoutSettings({
      ignoreProgramRecommendations: true,
      ...recommendedSettings,
      cardioOrResistance: workoutToChangeTo,
      ...newSettings,
    });
    getRecommendedSetttingsSuccess(customSettingsIgnoredFromProgram);
    getNextBookingProcessStep(userProfile, ProcessTypes.WorkoutSettings);
  };

  return (
    <TypeOfWorkoutWarning
      isWorkoutTypeChangeLoading={false}
      workoutToChangeTo={workoutToChangeTo}
      saveAndClose={saveAndClose}
      onBackPress={onBackPress}
      Heading={renderWarningHeader}
      textColor={{ color: theme.BLACK }}
      containerStyle={{ marginTop: -headerOffset }}
    />
  );
}

const mapStateToProps = (state: IAppStore) => ({
  recommendedSettings: recommendedSettingsSelector(state),
  workoutToChangeTo: state.bookings.bookingWizard.wokoutTypeWarning,
});

const mapDispatchToProps = (dispatch) => ({
  getNextBookingProcessStep: (userProfile, processType) => dispatch(
    getNextBookingStep(userProfile, processType, undefined, undefined),
  ),
  getRecommendedSetttingsSuccess: (workoutSettings: WorkoutSettings) => dispatch(
    workoutSettingsUpdated(workoutSettings),
  ),
  openPersonaliseSetupScreen: (screen: PersonaliseSetupScreens) => dispatch(openPersonaliseWorkoutSetupScreen(screen)),
});

export const TypeOfWorkoutWarningStep = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TypeOfWorkoutWarningStepComponent);
